import { render, staticRenderFns } from "./Wap_JLCT82_Step1.vue?vue&type=template&id=2171f63c&scoped=true&"
import script from "./Wap_JLCT82_Step1.vue?vue&type=script&lang=js&"
export * from "./Wap_JLCT82_Step1.vue?vue&type=script&lang=js&"
import style0 from "./Wap_JLCT82_Step1.vue?vue&type=style&index=0&id=2171f63c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2171f63c",
  null
  
)

export default component.exports